export default __webpack_public_path__ + "static/media/Malnadkitchen.d4d04944.png";